/* eslint-disable no-nested-ternary */
import { MultiJumpInfo, MultiJumpType } from '../types';

/** 是否是小程序跳转 */
export function isMiniappJump(jumpInfo?: MultiJumpInfo) {
  return !!(jumpInfo?.appid || jumpInfo?.username);
}

/** 是否是 H5 跳转 */
export function isH5Jump(jumpInfo?: MultiJumpInfo) {
  return !!jumpInfo?.jumpUrl;
}

/** 获取跳转类型 */
export function getJumpType(jumpInfo?: MultiJumpInfo) {
  return isMiniappJump(jumpInfo) ? MultiJumpType.Mp : isH5Jump(jumpInfo) ? MultiJumpType.H5 : MultiJumpType.Other;
}
